//
// AGNES - Technical Support Web
//
// TechnicalSupportBrowseTechReportController.js
//
// Copyright (c) 2015 Toyota Central Europe - Czech s.r.o.
//
// Permission is hereby granted, free of charge, to any person
// obtaining a copy of this software and associated documentation
// files (the "Software"), to deal in the Software without
// restriction, including without limitation the rights to use,
// copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the
// Software is furnished to do so, subject to the following
// conditions:
//
// The above copyright notice and this permission notice shall be
// included in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
// EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES
// OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
// NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT
// HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
// WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
// FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR
// OTHER DEALINGS IN THE SOFTWARE.
//

numerall = require('numeral');
parseDecimalNumber = require('parse-decimal-number');
numerall.register('locale', 'cs', {
    delimiters: {
        thousands: ' ',
        decimal: ','
    }
});

numerall.register('locale', 'hu', {
    delimiters: {
        thousands: ' ',
        decimal: ','
    }
});

numerall.register('locale', 'sk', {
    delimiters: {
        thousands: ' ',
        decimal: ','
    }
});

angular.module("Agnes")
    .controller("MenuPricingCatalogController", [
        "$scope", "$q", "$sessionStorage", "$http", "$activity", "$notification", "$translate", "$user", "$uibModal", "Blob", "FileSaver", "$oidc",
        function ($scope, $q, $sessionStorage, $http, $activity, $notification, translate, user, $modal, Blob, FileSaver, oidc) {
            // Storage
            $scope.$storage = $sessionStorage.$default({
                menuPricingCatalog: {
                    model: null,
                    type: null,
                    typeMenu: null,

                    orderName: "code",
                    orderDesc: true
                }
            });

            // Repairer
            $scope.$watch("$storage.repairer", function (newValue, oldValue) {
                if (!angular.isUndefinedNullOrEmpty(newValue) && newValue.id !== -1 && newValue.id !== oldValue.id) {
                    $scope.refresh();
                }
            });

            // Browse
            $scope.sorting = function (orderName) {
                if ($scope.$storage.menuPricingCatalog.orderName === orderName) {
                    $scope.$storage.menuPricingCatalog.orderDesc = !$scope.$storage.menuPricingCatalog.orderDesc;
                } else {
                    $scope.$storage.menuPricingCatalog.orderName = orderName;
                    $scope.$storage.menuPricingCatalog.orderDesc = false;
                }
            };

            $scope.sortingClass = function (orderName) {
                if ($scope.$storage.menuPricingCatalog.orderName === orderName) {
                    if ($scope.$storage.menuPricingCatalog.orderDesc) {
                        return "fa fa-caret-down";
                    } else {
                        return "fa fa-caret-up";
                    }
                } else {
                    return "";
                }
            };

            $scope.loadModels = function () {
                $activity.start();
                $http
                    .get("/api/menu-pricing/model/" + $scope.$storage.repairer.party.id, {
                        headers: {
                            Authorization: oidc.current.token_type + " " + oidc.current.access_token
                        }
                    })
                    .then(function (response) {
                        $scope.models = response.data;
                    }, function (response) {
                        $notification.addError(response.status, response);
                    }).then(function () {
                        $activity.finish();
                    });
            };

            $scope.loadMenuTypes = function () {
                $activity.start();
                $http
                    .get("/api/menu-pricing/menu-type", {
                        headers: {
                            Authorization: oidc.current.token_type + " " + oidc.current.access_token
                        }
                    })
                    .then(function (response) {
                        $scope.menuTypes = response.data;
                    }, function (response) {
                        $notification.addError(response.status, response);
                    }).then(function () {
                        $activity.finish();
                    });
            };

            $scope.loadMenuItemTypes = function () {
                $activity.start();
                $http
                    .get("/api/menu-pricing/type", {
                        headers: {
                            Authorization: oidc.current.token_type + " " + oidc.current.access_token
                        }
                    })
                    .then(function (response) {
                        $scope.menuItemTypes = response.data;
                    }, function (response) {
                        $notification.addError(response.status, response);
                    }).then(function () {
                        $activity.finish();
                    });
            };

            $scope.$watch("$storage.menuPricingCatalog.model", function (newValue, oldValue) {
                if (!angular.isUndefinedNullOrEmpty($scope.$storage.repairer) && $scope.$storage.repairer.id !== -1)
                    $scope.refresh();
            });

            $scope.$watch("$storage.menuPricingCatalog.type", function (newValue, oldValue) {
                if (!angular.isUndefinedNullOrEmpty($scope.$storage.repairer) && $scope.$storage.repairer.id !== -1)
                    $scope.refresh();
            });

            $scope.$watch("$storage.menuPricingCatalog.typeMenu", function (newValue, oldValue) {
                if (!angular.isUndefinedNullOrEmpty($scope.$storage.repairer) && $scope.$storage.repairer.id !== -1)
                    $scope.refresh();
            });

            $scope.originAmount = 0;
            $scope.setOriginAmount = function (originAmount) {
                $scope.originAmount = originAmount;
            };

            function convertToDecimal(val){
                return parseDecimalNumber(val, numerall.localeData(translate.use()).delimiters);
            }

            $scope.setPrice = function (item) {
                if (convertToDecimal($scope.originAmount) !== convertToDecimal(item.price)) {
                    if (!angular.isUndefinedNullOrEmpty(item.priceLimitation) && convertToDecimal(item.price) > convertToDecimal(item.priceLimitation)) {
                        translate("PriceOverLimitError")
                            .then(function (translation) {
                                $notification.addError(translation);
                            });
                    } else {
                        if (angular.isUndefinedNullOrEmpty(item.catalogPriceId)) {
                            return createPrice(item);
                        }
                        else {
                            return updateAmount(item);
                        }
                    }
                }
            }

            function updateAmount(item) {
                $activity.start();
                $http
                    .put("/api/menu-pricing/catalog/price", {
                        catalogPriceId: item.catalogPriceId,
                        amount: item.price
                    }, {
                        headers: {
                            Authorization: oidc.current.token_type + " " + oidc.current.access_token
                        }
                    })
                    .then(function (response) {
                    }, function (response) {
                        $notification.addError(response.status, response);
                    }).then(function () {
                        $activity.finish();
                    });
            };

            function createPrice(item) {
                $activity.start();
                $http
                    .post("/api/menu-pricing/catalog/price", {
                        menuItemId: item.menuItemId,
                        amount: item.price,
                        repairerId: $scope.$storage.repairer.party.id
                    }, {
                        headers: {
                            Authorization: oidc.current.token_type + " " + oidc.current.access_token
                        }
                    })
                    .then(function (response) {
                        return $scope.refresh();
                    }, function (response) {
                        $notification.addError(response.status, response);
                    }).then(function () {
                        $activity.finish();
                    });
            };

            $scope.generateReportDialog = function () {
                $modal
                    .open({
                        template: require("../Templates/MenuPricingGenerateReport.html"),
                        controller: "MenuPricingGenerateReportController",
                        resolve: {
                            menuItemTypes: function () {
                                return $scope.menuItemTypes;
                            }, menuTypes: function () {
                                return $scope.menuTypes;
                            }
                        }
                    })
                    .result
                    .then(function (response) {
                        $activity.start();
                        return $http
                            .get('api/menu-pricing/catalog/report', {
                                params: {
                                    countryIds: response.selectedCountries.map(function (val) { return val.id }).join(','),
                                    brandIds: response.selectedBrands.map(function (val) { return val.id }).join(','),
                                    menuTypeIds: response.selectedMenuTypes.map(function (val) { return val.id }).join(','),
                                    menuItemTypeIds: response.selectedMenuItemTypes.map(function (val) { return val.id }).join(',')
                                },
                                responseType: 'arraybuffer',
                                headers: {
                                    Authorization: oidc.current.token_type + " " + oidc.current.access_token
                                }
                            })
                            .then(function (response) {
                                var contentDisposition = response.headers("content-disposition");
                                var regex = /filename="*([^"].+[^"])"*;/g;
                                var result = regex.exec(contentDisposition);
                                var fileName = result[1];
                                var data = new Blob([response.data], { type: response.headers("content-type") });
                                FileSaver.saveAs(data, fileName);
                            }, function (response) {
                                $notification.addError(response.status, response);
                            })
                            .then(function () {
                                $activity.finish();
                            })
                    }, function (response) {
                        return $q.reject();
                    });
            };

            $scope.refresh = function () {
                $activity.start();
                $http
                    .get("/api/menu-pricing/catalog",
                        {
                            params: {
                                partyId: $scope.$storage.repairer.party.id,
                                modelNameId: angular.isUndefinedNullOrEmpty($scope.$storage.menuPricingCatalog.model) ? null : $scope.$storage.menuPricingCatalog.model.id,
                                typeId: angular.isUndefinedNullOrEmpty($scope.$storage.menuPricingCatalog.type) ? null : $scope.$storage.menuPricingCatalog.type.id,
                                menuTypeId: angular.isUndefinedNullOrEmpty($scope.$storage.menuPricingCatalog.typeMenu) ? null : $scope.$storage.menuPricingCatalog.typeMenu.id
                            },
                            headers: {
                                Authorization: oidc.current.token_type + " " + oidc.current.access_token
                            }
                        })
                    .then(function (response) {
                        $scope.list = response.data;
                    }, function (response) {
                        $notification.addError(response.status, response);
                    }).then(function () {
                        $activity.finish();
                    });
            };

            $scope.clearFilter = function () {
                $scope.$storage.menuPricingCatalog.model = null;
                $scope.$storage.menuPricingCatalog.type = null;
                $scope.$storage.menuPricingCatalog.typeMenu = null;
                $scope.refresh();
            };

            $scope.user = user;

            // On Load
            if (!angular.isUndefinedNullOrEmpty($scope.$storage.repairer) && $scope.$storage.repairer.id !== -1) {
                $scope.loadModels();
                $scope.loadMenuTypes();
                $scope.loadMenuItemTypes();
                $scope.refresh();
            }
        }
    ]);